<template>
  <div class="qc-upload-files">
    <div class="qc-upload-button">
      <el-upload
        class="upload-files"
        drag
        :limit="1"
        action
        :on-change="handleUpload"
        :on-remove="handleRemove"
        :auto-upload="false"
        :multiple="false"
        :show-file-list="false"
        v-model:file-list="fileList"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload-text-align">
          <div class="el-upload__text-img">
            <img src="@/assets/images/icons/attachments-icon.svg" alt="" />
          </div>
          <div class="el-upload__text">
            <h3>Drag & drop file here</h3>
            <p>your file here, or browse</p>
          </div>
        </div>
      </el-upload>
    </div>
    <div class="sample-attachment-upload-file-block">
      <div v-for="(file, index) in fileList" :key="index">
        <ul class="sample-attachment-upload-file">
          <li>
            <div class="file-name-attachment">
              <img
                src="@/assets/images/icons/attachments/attachments_1.svg"
                alt=""
              />
              <p>{{ file.name }}</p>
              <el-button
                type="text"
                @click="remove"
                class="btn-close"
                size="sm"
              >
                <img
                  class="hover"
                  src="@/assets/images/icons/attachments/attachment-success.svg"
                  alt=""
                />
                <img
                  src="@/assets/images/icons/attachments/remove-button.svg"
                  alt=""
                  class="without-hover"
                />
              </el-button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    remove() {
      this.fileList = [];
      this.$emit("onUpdatedFile", null);
    },
    handleRemove() {
      this.fileList = [];
      this.$emit("onUpdatedFile", null);
    },
    handleUpload(file) {
      file.status = "success";
      file.percentage = 100;
      this.fileList[0] = file;
      this.$emit("onUpdatedFile", file);
    },
  },
};
</script>
<style lang="scss" scoped>
.sample-attachment-upload-file-block {
  .sample-attachment-upload-file {
    li {
      .file-name-attachment {
        display: inline-flex;
        align-items: center;
        padding: 7px 10px;
        border: 0.5px solid #e0e0e0;
        border-radius: 5px;
        height: 30px;
        min-width: 30%;
        max-width: 96%;
        margin: 0.75rem 0;
        img {
          padding: 0 10px;
          height: 15px;
          width: 15px;
        }
        p {
          color: #4f4f4f;
          white-space: nowrap;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .el-button {
          .without-hover {
            display: none;
            transition: all 0.2s ease-in-out;
          }
          .hover {
            display: block;
            transition: all 0.2s ease-in-out;
          }
          &:hover {
            .without-hover {
              display: block;
              transition: all 0.2s ease-in-out;
            }
            .hover {
              display: none;
              transition: all 0.2s ease-in-out;
            }
          }
        }
      }
    }
  }
}
</style>
